export enum Permissions {
    None = 'None',
    StockView = 'StockView',
    StockManage = 'StockManage',
    ActualCostView = 'ActualCostView',
}

export default Permissions;
